/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_Item_0_TitleInputs */

const en_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year`)
};

const es_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesor del Año de la Iowa PGA`)
};

const de_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrer des Jahres der Iowa PGA`)
};

const zh_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年度最佳教师`)
};

const ar_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم العام في Iowa PGA`)
};

const fr_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignant de l’année de la Iowa PGA`)
};

const vi_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giáo viên của năm của Iowa PGA`)
};

const sw_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwalimu Bora wa Mwaka wa Iowa PGA`)
};

const th_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ครูแห่งปีของ Iowa PGA`)
};

const bs_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitelj godine Iowa PGA`)
};

const ja_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年間最優秀教師賞`)
};

const ko_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 올해의 교사`)
};

const pt_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professor do Ano da Iowa PGA`)
};

const it_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insegnante dell’anno della Iowa PGA`)
};

const sv_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lärare i Iowa PGA`)
};

const nl_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leraar van het Jaar van de Iowa PGA`)
};

const da_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets træner i Iowa PGA`)
};

const nb_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lærer i Iowa PGA`)
};

const fi_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n vuoden opettaja`)
};

const pl_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauczyciel Roku Iowa PGA`)
};

const ru_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учитель года Iowa PGA`)
};

const tr_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Yılın Öğretmeni`)
};

const hi_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA वर्ष के सर्वश्रेष्ठ शिक्षक`)
};

const id_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year`)
};

const ms_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year`)
};

const cs_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitel roku Iowa PGA`)
};

const el_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δάσκαλος της Χρονιάς της Iowa PGA`)
};

const he_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מורה השנה של Iowa PGA`)
};

const af_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Onderwyser van die Jaar`)
};

const hu_about_content_honor_0_item_0_title = /** @type {(inputs: About_Content_Honor_0_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA év tanára`)
};

/**
* | output |
* | --- |
* | "Iowa PGA Teacher of the Year" |
*
* @param {About_Content_Honor_0_Item_0_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_item_0_title = /** @type {((inputs?: About_Content_Honor_0_Item_0_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_Item_0_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_item_0_title(inputs)
	if (locale === "de") return de_about_content_honor_0_item_0_title(inputs)
	if (locale === "zh") return zh_about_content_honor_0_item_0_title(inputs)
	if (locale === "ar") return ar_about_content_honor_0_item_0_title(inputs)
	if (locale === "fr") return fr_about_content_honor_0_item_0_title(inputs)
	if (locale === "vi") return vi_about_content_honor_0_item_0_title(inputs)
	if (locale === "sw") return sw_about_content_honor_0_item_0_title(inputs)
	if (locale === "th") return th_about_content_honor_0_item_0_title(inputs)
	if (locale === "bs") return bs_about_content_honor_0_item_0_title(inputs)
	if (locale === "ja") return ja_about_content_honor_0_item_0_title(inputs)
	if (locale === "ko") return ko_about_content_honor_0_item_0_title(inputs)
	if (locale === "pt") return pt_about_content_honor_0_item_0_title(inputs)
	if (locale === "it") return it_about_content_honor_0_item_0_title(inputs)
	if (locale === "sv") return sv_about_content_honor_0_item_0_title(inputs)
	if (locale === "nl") return nl_about_content_honor_0_item_0_title(inputs)
	if (locale === "da") return da_about_content_honor_0_item_0_title(inputs)
	if (locale === "nb") return nb_about_content_honor_0_item_0_title(inputs)
	if (locale === "fi") return fi_about_content_honor_0_item_0_title(inputs)
	if (locale === "pl") return pl_about_content_honor_0_item_0_title(inputs)
	if (locale === "ru") return ru_about_content_honor_0_item_0_title(inputs)
	if (locale === "tr") return tr_about_content_honor_0_item_0_title(inputs)
	if (locale === "hi") return hi_about_content_honor_0_item_0_title(inputs)
	if (locale === "id") return id_about_content_honor_0_item_0_title(inputs)
	if (locale === "ms") return ms_about_content_honor_0_item_0_title(inputs)
	if (locale === "cs") return cs_about_content_honor_0_item_0_title(inputs)
	if (locale === "el") return el_about_content_honor_0_item_0_title(inputs)
	if (locale === "he") return he_about_content_honor_0_item_0_title(inputs)
	if (locale === "af") return af_about_content_honor_0_item_0_title(inputs)
	if (locale === "hu") return hu_about_content_honor_0_item_0_title(inputs)
	return en_about_content_honor_0_item_0_title(inputs)
});